<div class="form-row">
    <div class="form-group">
        <datepicker-fc
            [id]="id() + '-start-date'"
            [control]="startDate"
            [view]="'month'"
            [minDate]="feeWaiverStatus() === waiverStatusEnum.ACTIVE ? undefined : firstDayOfCurrentMonth"
            [required]="true"
            [showClear]="showClear()"
            [showButtonBar]="false"
            [selectionMode]="'single'"
            [size]="'small'" />
    </div>
    <i class="fa-regular fa-arrow-right fa-xl"></i>
    <div class="form-group">
        <datepicker-fc
            [id]="id() + '-end-date'"
            [control]="endDate"
            [view]="'month'"
            [minDate]="waiverWithMonthInPast() ? lastMonthDate : firstDayOfCurrentMonth"
            [required]="true"
            [showClear]="showClear()"
            [showButtonBar]="false"
            [selectionMode]="'single'"
            [size]="'small'" />
    </div>
</div>
<div class="group-waiver-period-info">
    @if (formGroup.errors?.['startDateInvalid'] || formGroup.errors?.['newStartDateInvalid']) {
        <form-error [text]="'group.feeWaivers.manageWaivers.startDateInvalid'" />
    } @else if (isExpiringWaiver()) {
        <div [style.margin-top]="'1rem'">
            <message [severity]="'warn'" [text]="'group.feeWaivers.manageWaivers.expiringWaiver'"></message>
        </div>
    } @else if (feeWaiverInterval()) {
        <p [style.margin-top]="'1rem'" [innerHTML]="feeWaiverIntervalInfo()"></p>
    }
</div>
